// extracted by mini-css-extract-plugin
export default {"note":"styles_note__d+N5M","errorBar":"styles_errorBar__MFb-J","buttons":"styles_buttons__18r1W","input":"styles_input__JYhUp"};